module.exports = __webpack_public_path__ + "img/品牌.13dcdb44.webp";